export default {
    getRequestByUid: (state) => (uid) => {
      return state.list.find(request => request.uid === uid)
    },

    isNew: () => (instance) => {
        return instance.is_new;
    },
}